import React, { useState } from 'react';
import { useUser, UserData } from '../context/UserContext';
import './AccountCreation.css';

const AccountCreation: React.FC = () => {
  const { saveUserData } = useUser();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    address: '',
    phone: '',
    email: '',
  });

  const calculateAge = (dobString: string) => {
    const dob = new Date(dobString);
    if (isNaN(dob.getTime())) return 0;
    const ageDifMs = Date.now() - dob.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Construct UserData matching the user.json structure
    const newUserData: UserData = {
      personalInfo: {
        ...formData,
        fullName: `${formData.firstName} ${formData.lastName}`.trim(),
        age: calculateAge(formData.dateOfBirth)
      },
      documents: []
    };

    saveUserData(newUserData);
  };

  return (
    <div className="account-creation-container">
      <div className="account-creation-card">
        <h1 className="account-creation-title">Welcome to Matilda</h1>
        <p className="account-creation-subtitle">Let's set up your profile to personalize your experience.</p>
        
        <form onSubmit={handleSubmit} className="account-creation-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                placeholder="Brad"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                placeholder="Ragazinsky"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="brad.ragazinsky@gmail.com"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="dateOfBirth">Date of Birth</label>
              <input
                type="date"
                id="dateOfBirth"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="301-467-8609"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
              placeholder="9645 Park Preserve Drive, Fairfax, VA, 22032"
            />
          </div>

          <button type="submit" className="account-creation-submit">
            Complete Profile
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccountCreation;
